import { GuestCommentOnRecipeMeta, GuestCommentOnRecipePayload } from 'types/store/GuestCommentOnRecipe';
import { createAsyncAction } from 'utils/Redux';

const ns = 'GUEST_COMMENT_ON_RECIPE_NS';

const asyncAction = createAsyncAction<GuestCommentOnRecipeMeta, GuestCommentOnRecipePayload>(ns);

const guestCommentOnRecipeActions = { ...asyncAction };

export default guestCommentOnRecipeActions;
